<template>
  <div class="data-history__variables-list border rounded">
    <s-loader
      v-show="loadingVariables"
      class="py-5"
      size="lg"
    />

    <s-empty-list v-if="!loadingVariables && !(variables || []).length"/>

    <div v-if="!loadingVariables && (variables || []).length">
      <b-row
        class="data-history__variables-row"
        v-for="variable in variables"
        :key="variable.assetModuleVariableId"
        @click.prevent="selectVariable(variable)"
      >
        <b-col>
          <div class="data-history__variable-content">
            <div class="data-history__variable-hierarchy small">
              {{ getVariableHierarchyTitle(variable) }}
            </div>
            <div class="">
              <div class="data-history__variable-checkbox d-inline-block">
                <b-checkbox
                  class="d-inline-block"
                  :checked="isVariableSelected(variable.assetModuleVariableId)"
                  @change="selectVariable(variable)"
                  @click.native.stop
                />
              </div>
              <div class="data-history__variable-name d-inline-block">
                {{ variable.variableName }}
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DataHistoryVariablesList',
  props: {
    variables: {
      type: Array,
      default: () => ([]),
    },
    selectedVariables: {
      type: Array,
      default: () => ([]),
    },
    loadingVariables: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getVariableHierarchyTitle(
      {
        companyName,
        regionalName,
        installationName,
        assetName,
        moduleName,
      },
    ) {
      return `${companyName}/${regionalName || ''}/${installationName}/${assetName}/${moduleName}`
        .replace(/\/\//g, '/')
        .replace(/\//g, ' / ');
    },
    isVariableSelected(variableId) {
      return !!this.selectedVariables
        .find(({ assetModuleVariableId: id }) => id === variableId);
    },
    selectVariable(variable) {
      this.$emit('select-variable', variable);
    },
  },
};
</script>

<style lang="sass" scoped>
.data-history
  &__variables-list
    overflow-x: auto
    max-height: 38.5rem

  &__variables-row
    margin: 0
    padding: 8px 15px 8px 0
    background: var(--color-table-body-bg)
    cursor: pointer

    &:nth-child(2n)
      background: var(--color-background-regular)

    &:hover
      background: var(--color-background-regular-hover)

  &__variable-content
    position: relative

  &__variable-checkbox
    position: absolute
    vertical-align: top

  &__variable-hierarchy
    color: var(--color-gray-intermediary-darker)

  &__variable-hierarchy,
  &__variable-name
    padding-left: 2rem

  &__variable-row
    max-width: calc(100% - 2rem)
</style>
